import React, { useState } from 'react';
import AssetBannerFooterProps from './AssetBannerFooterProps';
import clsx from 'clsx';
import './AssetBannerFooter.scss';
import i18next from 'i18next';
import Utils from '../../../../utils/Utils';
import Instagram from '../../../medium/vip-form/SocialModal/instagram.svg';
import Facebook from '../../../medium/vip-form/SocialModal/facebook.svg';
import Tiktok from '../../../medium/vip-form/SocialModal/tiktok-logo.svg';
import { Link } from 'react-router-dom';
import TwitterIcon from '@material-ui/icons/Twitter';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const AssetBannerFooter: React.FC<AssetBannerFooterProps> = (props) => {

    const [isDescriptionCollapsed, setIsDescriptionCollapsed] = useState(true);

    return (
        <div className="asset-banner-footer">
            <div className="content-container">

                <div className="content-banner">
                    <div className="social-container">
                        {!!props.instagram && (
                            <Link to={{ pathname: props.instagram }} target="_blank" >
                                <img src={Instagram} style={{ height: 'auto', width: 30 }} />
                            </Link>
                        )}
                        {!!props.facebook && (
                            <Link to={{ pathname: props.facebook }} target="_blank" >
                                <img src={Facebook} style={{ height: 'auto', width: 30 }} />
                            </Link>
                        )}
                        {!!props.twitter && (
                            <Link to={{ pathname: props.twitter }} target="_blank" >
                                <TwitterIcon id="icon-twitter" />
                            </Link>
                        )}
                        {!!props.tiktok && (
                            <Link to={{ pathname: props.tiktok }} target="_blank" >
                                <img src={Tiktok} style={{ height: 'auto', width: 30 }} />
                            </Link>
                        )}
                    </div>

                    <div className="price-container">
                        <div className="price-case">
                            <p className="no-margin price">{Utils.toKorM(props.totalAssetValue, 0)}</p>
                            <p className="no-margin price-label">{i18next.t('Assetprofilebannerfooter.totalvalue')}</p>
                        </div>

                        <div className="price-case">
                            <p className="no-margin price">{Utils.toKorM(props.assetCurrentPrice, 2)}</p>
                            <p className="no-margin price-label">{i18next.t('Assetprofilebannerfooter.currentprice')}</p>
                        </div>

                        <div className="price-case">
                            <p className={clsx('no-margin price', {
                                'total-earnings-up': props.lastChange >= 0,
                                'total-earnings-down': props.lastChange < 0,
                            })}>{props.lastChange >= 0 ? '+' : ''}{props.lastChange ? props.lastChange.toFixed(2) : 0}%</p>
                            <p className="no-margin price-label">{i18next.t('Assetprofilebannerfooter.totalchange')}</p>
                        </div>
                    </div>
                </div>
                {!!props.description &&
                    <>
                        <Collapse in={!isDescriptionCollapsed} collapsedHeight={74}>
                            <div className="description-container">
                                <p>{props.description}</p>
                            </div>
                        </Collapse>
                        <div className="collapse-border">
                            <button>
                                {isDescriptionCollapsed &&
                                    <ExpandMoreIcon
                                        onClick={() => setIsDescriptionCollapsed(false)}
                                    />
                                }
                                {!isDescriptionCollapsed &&
                                    <ExpandLessIcon
                                        onClick={() => setIsDescriptionCollapsed(true)}
                                    />
                                }
                            </button>
                        </div>
                    </>
                }

            </div>
            {!!props.youtubeVideo &&
                <div className="video-container">
                    <iframe width="280" height="157" src={`https://www.youtube.com/embed/${props.youtubeVideo}`}
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
                </div>
            }
        </div>
    );
};

export default AssetBannerFooter;
